import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { colors } from '../../utils/theme';
import { PRScrollView } from '../shared/Scroll';

export type DetailsLayoutOwnProps = {
    children: React.ReactNode | React.ReactNode[];
    testID?: string;
    contentContainerStyle?: StyleProp<ViewStyle>;
};

export type DetailsLayoutProps = DetailsLayoutOwnProps;

const DetailsLayout: React.FC<DetailsLayoutProps> = (props) => {
    return (
        <PRScrollView
            style={{
                width: '100%',
                flex: 1,
                backgroundColor: colors['White'],
            }}
            testID={props.testID}
            contentContainerStyle={[
                {
                    flexGrow: 1,
                    width: '100%',
                },
                props.contentContainerStyle,
            ]}
        >
            {props.children}
        </PRScrollView>
    );
};

export default React.memo(DetailsLayout);
